module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-crying-a10e7d9f02aeba7244d4b060e3f6ec1f.svg";